import React from 'react';
import VimeoEmbed from '../../Shared/VimeoEmbed'
import styles from './Testimonials.module.scss';
import Img from 'gatsby-image'
import Link from 'gatsby-link'

import { mobileos } from '../../../utils/Browser'

const Testimonials = (props) => {
    return (
      <div className={styles.Story}>
        <div className={styles.Story__Wrapper}>
        <div className={`${styles.Strokes}${mobileos ? ` ${styles.REDUCED}` : ''}`}>
        </div>
          <div className={`${styles.StoryItem} ${styles.StoryItemTwo}`}>
            <div className={styles.StoryItemTwo__Left}>
              <div>
                <Img className="profile-image" sizes={props.testimonials[1].profileImage.sizes} alt={props.testimonials[1].profileImage.title} />
                <h3>{props.testimonials[1].title}</h3>
                { /* <a className="hoverlink c-white" href={props.testimonials[1].link.link}>{props.testimonials[1].link.text}</a> */ }
              </div>
            </div>
            {
                mobileos == null &&
                <div className={styles.StoryItemTwo__Right}>
                  <p className="animated">{props.testimonials[1].quote}</p>
                  <VimeoEmbed
                    url={props.testimonials[1].videoLink}
                    loop={false}
                    autoplay={false}
                    controls={true}
                  />
                </div>
            }
          </div>
          <div className={styles.Strokes}>
            <img className={styles.Strokes__Blue} src="/images/yellow-strokes-tall.png" alt="Yellow stroke" />
          </div>
          <div className={`${styles.StoryItem} ${styles.StoryItemThree}`}>
          {
              (mobileos == null || mobileos[0] == 'ipad') &&
              <div className={styles.StoryItemThree__Right}>
                <Img className="featuredImage" sizes={props.testimonials[2].featuredMedia.sizes} alt={props.testimonials[2].featuredMedia.title} />
              </div>
          }
            <div className={styles.StoryItemThree__Left}>
              <Img className="profile-image" sizes={props.testimonials[2].profileImage.sizes} alt={props.testimonials[2].profileImage.title} />
              <h3>{props.testimonials[2].title}</h3>
              <p className="animated">{props.testimonials[2].quote}</p>
              <Link className="hoverlink" to={props.testimonials[2].link.link} title={props.testimonials[2].link.text}>{props.testimonials[2].link.text}</Link>
            </div>
          </div>

        </div>
      </div>
    )

}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/_Redesign/Testimonials/index.js